var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standard-page',{attrs:{"module":_vm.module},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('process-list',{attrs:{"source":"pending"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }